/**
 * Store Creation Statuts
 */
export default {
    state: {
        statuts: [],
        statutEnCours: 1,
        statutSupervise: 5,
    },

    mutations: {
        /**
         * Initialise le state statuts
         */
        setCreationStatuts: function (state, statuts) {
            state.statuts = statuts
        }
    },

    getters: {
        /**
         * Liste d'options de statuts de dossiers
         */
        optionsCreationStatuts: state => {
            return state.statuts.map(statut => {
                return {label: statut.nom, value: statut.id}
            })
        },

        /**
         * Récupère le libelle du statut
         */
        getLibelleCreationStatut: state => id => {
            let statut = state.statuts.find(statut => statut.id === parseInt(id))
            return statut ? statut.nom : ''
        }
    }
}
